"use client"

import SettingsTable from "@/components/settings/SettingsTable"
import { SettingsSchema } from "@/schemas/settings.schema"
import { getSettings } from "@/services/settings.service"
import { useEffect, useState } from "react"
import { z } from "zod"

export default function SettingsPage(){
    const [settings, setSettings] = useState<z.infer<typeof SettingsSchema>[]>([]);

    const fetchSettings = async () => {
        console.log("Fetching settings");
        try {
            const settings = await getSettings();
            setSettings(settings);
        } catch (error) {
            return false;
        }

        return true;
    }

    useEffect(() => {
        fetchSettings();
    }, []);
    return (
        <SettingsTable updateData={fetchSettings} settings={settings} />
    )
}